// extracted by mini-css-extract-plugin
module.exports = {"CountriesFeature":"vr_a bha_b"};